import React from "react";
import Select from "react-select";

const groupedOptions = [
    {
        label: "OpenAI",
        options: [
            { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo" },
            { value: "gpt-4o", label: "GPT-4o" },
            { value: "gpt-4o-mini", label: "GPT-4o-mini" },
            { value: "gpt-4.5-preview", label: "GPT4.5-preview" },
        ],
    },
    {
        label: "GroqAI",
        options: [
            { value: "openai/gpt-oss-20b", label: "GPT-OSS 20B (Groq Free)" },
            { value: "openai/gpt-oss-120b", label: "GPT-OSS 120B (Groq Free)" },
        ],
    },
];

const AIModelSelect = ({ onChange }:any) => {
    const handleChange = (selectedOption:any) => {
        if (!selectedOption) return;

        // Tìm group label tương ứng
        const foundGroup = groupedOptions.find(group =>
            group.options.some(opt => opt.value === selectedOption.value)
        );

        onChange(selectedOption.value, foundGroup?.label || "");
    };

    return (
        <div className="mb-4">
            <Select
                options={groupedOptions}
                onChange={handleChange}
                placeholder="chọn AI model..."
                isSearchable
                className="text-sm"
                styles={{
                    container: (base) => ({
                        ...base,
                        width: 200, // hoặc '280px'
                    }),
                }}
            />
        </div>
    );
};

export default AIModelSelect;
